import { useEffect, useState } from "react";
import * as authActions from "../ducks/auth";
import { selectMe, selectStatus } from "../ducks/auth/selectors";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router";
import { useAppDispatch } from "../redux-store";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress } from "@mui/material";

interface MeProps {
  me: authActions.Me;
}

function withAuth<T>(
  Component: React.ComponentType<T & MeProps>
): React.ComponentType<T> {
  return (props: T) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("authPage");
    const state = useSelector(selectStatus);

    useEffect(() => {
      if (state === "UNINITIALIZED") {
        dispatch(authActions.init());
      }
      if (state === "AUTH_ERROR") {
        setTimeout(() => {
          dispatch(authActions.init());
        }, 1000);
        setAuthErrorEncountered(true);
      }
    }, [state, dispatch]);

    const me = useSelector(selectMe);
    const location = useLocation();
    const [authErrorEncountered, setAuthErrorEncountered] = useState(false);

    switch (state) {
      case "UNINITIALIZED":
      case "INITIALIZING":
      case "AUTH_ERROR":
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <br />
            <br />
            <CircularProgress style={{ color: "black" }} size={44} />
            <br />
            <br />
            {authErrorEncountered && (
              <p style={{ textAlign: "center" }}>
                {t("problemAuthenticating")}
              </p>
            )}
          </Box>
        );
      case "AUTHENTICATED":
        return <Component {...props} me={me!} />;
      case "UNAUTHENTICATED":
        return (
          <Navigate
            to="/login"
            state={{
              returnPath: location.pathname,
              returnQuery: location.search,
            }}
          />
        );
      case "ERROR_OFFLINE":
        return <p>{t("problemReachingServer")}</p>;
    }
  };
}

export default withAuth;
